var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "my-bookmark__tag-list__item", on: { click: _vm.select } },
    [
      _c(
        "a",
        {
          class: [
            "my-bookmark__tag-list__link",
            "#bookmark_tag",
            _vm.isSelected ? "my-bookmark__tag-list__link--selected" : "",
          ],
          attrs: { href: "javascript:", role: "button" },
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.tag.tagString))]),
          _vm._v(" "),
          _vm.isSelected
            ? _c("span", { staticClass: "ico-checked" }, [
                _c("span", { staticClass: "sr_only" }, [_vm._v("선택됨")]),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }